// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/condicionalService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import { paramsDaLista, type ListaFiltros, type PaginadoComResumo, type CondicionalListaResumo } from './listaFiltros';
import type {
  CondicionalResumo,
  CondicionalDetalhe,
  CriarCondicionalRequest,
  AtualizarCondicionalRequest,
  RegistrarDevolucaoRequest,
  AcertoCondicionalRequest,
  CondicionalExpiracaoResultado,
} from '../types';

const BASE = '/api/condicionais';

export const condicionalService = {
  async getAll(pagina = 1, tamanhoPagina = 20, filtros: ListaFiltros = {}): Promise<PaginadoComResumo<CondicionalResumo, CondicionalListaResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<CondicionalResumo, CondicionalListaResumo>>(BASE, {
      params: paramsDaLista(pagina, tamanhoPagina, filtros),
    });
    return data;
  },

  async getAbertas(): Promise<CondicionalResumo[]> {
    const { data } = await apiClient.get<CondicionalResumo[]>(`${BASE}/abertas`);
    return data;
  },

  async getVencidas(): Promise<CondicionalResumo[]> {
    const { data } = await apiClient.get<CondicionalResumo[]>(`${BASE}/vencidas`);
    return data;
  },

  async expirarVencidas(): Promise<CondicionalExpiracaoResultado> {
    const { data } = await apiClient.post<CondicionalExpiracaoResultado>(`${BASE}/expirar-vencidas`);
    return data;
  },

  async getById(id: number): Promise<CondicionalDetalhe> {
    const { data } = await apiClient.get<CondicionalDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async create(request: CriarCondicionalRequest): Promise<CondicionalDetalhe> {
    const { data } = await apiClient.post<CondicionalDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarCondicionalRequest): Promise<CondicionalResumo> {
    const { data } = await apiClient.put<CondicionalResumo>(`${BASE}/${id}`, request);
    return data;
  },

  async registrarDevolucao(id: number, request: RegistrarDevolucaoRequest): Promise<CondicionalDetalhe> {
    const { data } = await apiClient.put<CondicionalDetalhe>(`${BASE}/${id}/devolucao`, request);
    return data;
  },

  async acertar(id: number, request: AcertoCondicionalRequest): Promise<CondicionalDetalhe> {
    const { data } = await apiClient.put<CondicionalDetalhe>(`${BASE}/${id}/acerto`, request);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
